import React from 'react';
import classNames from 'classnames';
import { useAtom } from 'jotai';
import InfoIcon from '../../assets/icons/info.svg';
import IconButton from '../IconButton';
import ManagersPhonesInfoModal from '../ManagersPhonesInfoModal';
import { closeModalAtom, modalStateAtom } from '../../atoms/globalAtoms';
import styles from './css/index.module.scss';

function InformingBlockTitle({ title, titleClassName, className, iconWrapperClassName }) {
  const [, setModalState] = useAtom(modalStateAtom);
  const [, closeModal] = useAtom(closeModalAtom);

  const onInfoClick = () => {
    setModalState({
      isOpen: true,
      children: <ManagersPhonesInfoModal closeModal={closeModal} />,
    });
  };

  return (
    <div className={classNames(styles.titleRow, className)}>
      <p className={titleClassName}>{title}</p>
      <IconButton
        svgPath={InfoIcon}
        onClick={onInfoClick}
        wrapperClassName={classNames(styles.infoIconButton, iconWrapperClassName)}
      />
    </div>
  );
}

export default InformingBlockTitle;
